import { nameValuePropType } from '@deltek/specification-client/core/Models/nameValuePropType'
import React from 'react'
import ProjectInput, { ProjectInputProps } from './ProjectInput'

export interface ProjectInputSingleProps extends ProjectInputProps {
    value: string | null | undefined
    handleChange: (name: string, value: string | null | undefined) => void
    openProjectGroupDialog?: VoidFunction
    openProjectOwnerDialog?: VoidFunction
    isAdmin?: boolean
    isOwnerDisabled?: boolean
    htmlAutoCmpltDisabled?: boolean
    disable?: boolean
    openRemoveParameterDialog?: (
        parameterId: string, 
        onSuccessCallback?: () => void, 
        onCancelCallback?: () => void
    ) => void
}

const ProjectInputSingle: React.FC<ProjectInputSingleProps> = ({
    options,
    value,
    name,
    label,
    placeholder,
    maxLength,
    required,
    error,
    handleChange,
    openProjectGroupDialog,
    openProjectOwnerDialog,
    isAdmin,
    isOwnerDisabled,
    htmlAutoCmpltDisabled,
    disable,
    openRemoveParameterDialog
}) => {
    const projectInputProps = {
        options,
        name,
        label,
        placeholder,
        maxLength,
        required,
        error,
        optionValue: value,
        value:
            value === ''
                ? null
                : options.find(
                      (group: Record<nameValuePropType, string>) =>
                          group.value === value
                  ) || value,
        onChange: (
            _: React.ChangeEvent<{}>,
            item: Record<nameValuePropType, string>
        ) => options.length !== 0 && handleChange(name, item?.value),
        onInputChange: (_: React.ChangeEvent<{}>, item: string) => {
            options.length === 0 && handleChange(name, item)
        },
        getOptionLabel: (option: Record<nameValuePropType, string>) =>
            typeof option === 'string' ? option : option.name,
    }
    return (
        <ProjectInput
            {...projectInputProps}
            openProjectGroupDialog={openProjectGroupDialog}
            openProjectOwnerDialog={openProjectOwnerDialog}
            isAdmin={isAdmin}
            isOwnerDisabled={isOwnerDisabled}
            htmlAutoCmpltDisabled={htmlAutoCmpltDisabled}
            disable={disable}
            openRemoveParameterDialog={openRemoveParameterDialog}
        />
    )
}

export default ProjectInputSingle
